import { createSlice } from "@reduxjs/toolkit";
import { MagicPotsInitialLoad, MagicpotPaggination, MagicPotsDonationList, MagicPotsDonationListByPage } from "../thunk/MagicpotThunk";

const initialState = {
    magicpotevents: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
    magicpotdonationlist: []
};

export const MagicpoteventsSlice = createSlice({
    name: "magicpotevents",
    initialState,
    reducers: {
        resetMagicpot: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(MagicPotsInitialLoad.pending, (state) => {
                state.showLoading = true;
            })
            .addCase(MagicPotsInitialLoad.fulfilled, (state, action) => {
                state.magicpotevents = action.payload;
                state.showLoading = false;
            })
            .addCase(MagicPotsInitialLoad.rejected, (state, action) => {
                state.errorMessage = action.payload || action.error.message;
                state.showLoading = false;
            })
            .addCase(MagicpotPaggination.pending, (state) => {
                state.showLoading = true;
            })
            .addCase(MagicpotPaggination.fulfilled, (state, action) => {
                state.magicpotevents = action.payload;
                state.showLoading = false;
            })
            .addCase(MagicpotPaggination.rejected, (state, action) => {
                state.errorMessage = action.payload || action.error.message;
                state.showLoading = false;
            })
            .addCase(MagicPotsDonationList.pending, (state) => {
                state.showLoading = true;
            })
            .addCase(MagicPotsDonationList.fulfilled, (state, action) => {
                state.magicpotdonationlist = action.payload;
                state.showLoading = false;
            })
            .addCase(MagicPotsDonationList.rejected, (state, action) => {
                state.errorMessage = action.payload || action.error.message;
                state.showLoading = false;
            })
            .addCase(MagicPotsDonationListByPage.pending, (state) => {
                state.showLoading = true;
            })
            .addCase(MagicPotsDonationListByPage.fulfilled, (state, action) => {
                state.magicpotdonationlist = action.payload;
                state.showLoading = false;
            })
            .addCase(MagicPotsDonationListByPage.rejected, (state, action) => {
                state.errorMessage = action.payload || action.error.message;
                state.showLoading = false;
            });
    },
});

export const { resetMagicpot } = MagicpoteventsSlice.actions;
export const MagicpotReducer = MagicpoteventsSlice.reducer;
